const WeatherEnum = {
    Thunderstorm: 'thunderstorm',
    Drizzle: 'drizzle',
    Rain: 'rain',
    Snow: 'snow',
    Atmosphere: 'atmosphere',
    Sunny: 'sunny',
    Clouds: 'clouds'
}

export default WeatherEnum